import { render } from "./FeedbackPopUp.vue?vue&type=template&id=53c2a523&scoped=true"
import script from "./FeedbackPopUp.vue?vue&type=script&lang=js"
export * from "./FeedbackPopUp.vue?vue&type=script&lang=js"

import "./FeedbackPopUp.vue?vue&type=style&index=0&id=53c2a523&scoped=true&lang=css"

import exportComponent from "/Users/chrisfinlayson/Desktop/WORK/riverhawk-nest/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53c2a523"]])

export default __exports__